import { Form, Button } from "react-bootstrap";
import React, { useState } from "react";
import { callGraphEmail } from "../graph";
import { loginRequest } from "../authConfig";
import { useMsal } from "@azure/msal-react";

export default function ProfileContent() {
    const { instance, accounts } = useMsal();
    const [form, setForm] = useState({});

    const name = accounts[0] && accounts[0].name;

    const clear = () => {
        localStorage.clear();
    }

    function sendTheEmail() {
        const request = {
            ...loginRequest,
            account: accounts[0]
        };

        // Silently acquires an access token which is then attached to a request for Microsoft Graph data
        instance.acquireTokenSilent(request).then((response) => {
            callGraphEmail(response.accessToken, localStorage.getItem("recipientAddress"), localStorage.getItem("roomNumber")).then(response => console.log(response));
        }).catch((e) => {
            instance.acquireTokenPopup(request).then((response) => {
                callGraphEmail(response.accessToken).then(response => console.log(response));
            });
        });
    }

    const saveForm = () => {
        console.log(form);
        localStorage.setItem("recipientAddress", form.emailAddress);
        localStorage.setItem("roomNumber", form.roomNumber);
    };

    const setField = (field, value) => {
        setForm({
            ...form,
            [field]: value
        });
    };

    return (
        <>
            <h5 className="card-title">Welcome {name}</h5>
            <div class="row justify-content-center">
                <br />
                <Form style={{ width: "25%" }} onSubmit={saveForm}>
                    <Form.Group className="mb-3" controlId="formBasicEmail" >
                        <Form.Label>Recipient's Email Address</Form.Label>
                        <Form.Control
                            required
                            type="email"
                            name="emailAddress"
                            onChange={e => setField("emailAddress", e.target.value)}
                            placeholder={!localStorage.getItem("recipientAddress") ? "Please save an email address" : "Saved address: " + localStorage.getItem("recipientAddress")} />
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="formBasicEmail" >
                        <Form.Label>Room Number</Form.Label>
                        <Form.Control
                            required
                            name="roomNumber"
                            onChange={e => setField("roomNumber", e.target.value)}
                            placeholder={!localStorage.getItem("roomNumber") ? "Please type a room number" : "Saved room: " + localStorage.getItem("roomNumber")} />
                    </Form.Group>
                    <div class="row justify-content-center">
                        <p>Subject: Assistance Urgently Needed</p>
                        <p>Body: Please send administration or a school officer to room {localStorage.getItem("roomNumber")} ASAP.</p>
                    </div>
                    <div class="row justify-content-center">
                        <Button variant="primary" type="submit">
                            Save
                        </Button>
                    </div>
                </Form>
            </div>
            <br />
            <div class="row justify-content-center">
                {!localStorage.getItem("recipientAddress") || !localStorage.getItem("roomNumber") ?
                    <Button disabled style={{ background: "red", width: "25%", height: "80px" }} onClick={sendTheEmail}>I'm in trouble</Button>
                    : <Button style={{ background: "red", width: "25%", height: "80px" }} onClick={sendTheEmail}>I'm in trouble</Button>
                }
            </div>
            {/* <Button onClick={() => clear()}>clear</Button> */}
        </>
    );
};